module.exports = __webpack_public_path__ + "static/img/newFood6.399c0b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newFood6.png
// module id = 1f4Q
// module chunks = 2